import * as React from 'react';
const TableHeadContext = /*#__PURE__*/React.createContext(false);
TableHeadContext.displayName = 'TableHeadContext';
const useTableHeadContext = () => React.useContext(TableHeadContext);
export { TableHeadContext, useTableHeadContext };